<template>

</template>

<script>
import gql from 'graphql-tag'
import * as types from '@/store/actionTypes'
import { mapState } from 'vuex'

export default {
  name: 'SearchButton',

  data() {
    return {
      searchVariables: {}
    }
  },

  computed: {
    ...mapState({
      searchQuery: state => state.query,
      skip: state => state.skip,
      sort: state => state.sort
    })
  },

  watch: {
    searchQuery: {
      handler: function() {
        this.watchQueryHandler()
      },
      deep: true
    },
    skip: {
      handler: function() {
        this.handleSearch()
      }
    },
    sort: {
      handler: function() {
        this.handleSearch()
      }
    }
  },

  apollo: {
    search: {
      query: gql`
        query Search(
          $input: SearchInput!
          $sort: SortOrder
          $skip: Int
        ) {
          search(input: $input, sort: $sort, skip: $skip) {
            hits {
              city
              id
              matches {
                isMatch
                text
                type
                years
              }
            }
            total
          }
        }
      `,
      fetchPolicy: 'network-only',
      skip() {
        return Object.keys(this.searchVariables).length === 0
      },
      variables() {
        return {
          input: this.searchVariables,
          skip: this.skip,
          sort: this.sort
        }
      },
      update({ search }) {
        this.handleSearchResults(search)
      },
      error(error) {
        this.handleError(error)
      }
    }
  },

  methods: {
    handleSearch() {
      const input = {
        ...this.searchQuery,
        city: this.searchQuery.city.map(c => c.path).filter(Boolean),
        educations: this.searchQuery.educations.map(e => {
          const eCopy = { ...e }

          delete eCopy.name
          delete eCopy.path

          return eCopy
        })
      }

      this.searchVariables = input
    },
    handleSearchResults(search) {
      this.$store.commit(types.SET_RESULTS, search)
    },
    handleError(error) {
      this.$store.commit(types.SET_RESULT_ERROR, error)
    },
    watchQueryHandler() {
        const hasNoQuery = Object.values(this.searchQuery).filter(category => category.length).length === 0
        if (hasNoQuery) {
          this.$store.commit(types.SET_NO_RESULTS)
          return
        }
        this.handleSearch()
        this.$store.commit(types.SET_SKIP, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Search/SearchButton.vue